export default __webpack_public_path__ + "static/media/jp.4e5a076a.svg";